import React, { FC } from 'react';
import format from 'date-fns/format';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Card } from '../../card';
import { Section } from '../../section';
import { SimpleHero } from '../../simpleHero/SimpleHero';
import { Pagination } from '../../pagination/Pagination';

// Interface

export interface ArticleListingProps {
  heading: string;
  description?: string;
  items: any; // temp will be using a typegen type
  pageContext: any; // TODO
}

// Styles

const StyledGrid = styled.div`
  ${({ theme: { space, colors, media } }) => css`
    display: grid;
    gap: ${space.medium};

    .gatsby-image-wrapper-constrained {
      width: 100%;
    }

    @media (min-width: ${media.medium}) {
      grid-template-columns: ${`repeat(2, 1fr)`};

      > div:first-of-type {
        grid-column: 1 / -1;

        flex-direction: row;
        gap: ${space.large};
        margin-bottom: ${space.large};

        > * {
          flex-basis: 50%;
        }
      }
    }

    @media (min-width: ${media.large}) {
      grid-template-columns: ${`repeat(3, 1fr)`};
      grid-row-gap: ${space.xLarge};

      > div:first-of-type {
        grid-column: 1 / -1;

        .gatsby-image-wrapper {
          margin-bottom: 0;

          > div {
            max-width: unset;
          }
        }
      }
    }
  `};
`;

// JSX

export const ArticleListing: FC<ArticleListingProps> = ({
  heading,
  description,
  items,
  pageContext,
  display,
}) => {
  const { pageNumber, pathName, totalCount } = pageContext;
  const generatePageUrl = (pageNum: number): string =>
    `${pathName}/${pageNum > 1 ? `${pageNum}` : ''}`;

  return (
    <>
      {/* Simple Hero */}
      <SimpleHero
        heading={heading}
        description={description}
        backgroundColor="neutralWhite"
      />

      {/* Items */}
      <Section>
        <StyledGrid>
          {items?.length >= 1 &&
            items.map(({ id, url, name, publishDate, properties }, index) => (
              <Card
                heading={properties?.feed?.shortTitle || name}
                description={properties?.feed?.shortDescription}
                metaDetail={format(
                  new Date(publishDate as Date),
                  'dd MMMM yyyy'
                )}
                image={properties?.feed?.featuredImage?.image?.localFile}
                url={url}
                label="Read more"
                key={id}
                background="none"
                isFirst={index === 0}
              />
            ))}
        </StyledGrid>
      </Section>
      {/* Pagination */}
      {totalCount > 10 && (
        <Section>
          <Pagination
            linkGenerator={generatePageUrl}
            totalCount={totalCount}
            currentPage={pageNumber}
            pageSize={10}
          />
        </Section>
      )}
    </>
  );
};

export default ArticleListing;
